<template>
  <div class="understanding-bar" :class="`understanding-bar--${state}`">
    <template v-if="state === 'empty'">
      <span class="understanding-bar__placeholder">先简单描述你的技术问题，一句话也可以。</span>
    </template>
    <template v-else-if="state === 'short'">
      <span class="understanding-bar__placeholder">再输入几个字（至少 8 个字），我就能开始理解</span>
    </template>
    <template v-else-if="state === 'typing' && !sentence">
      <span class="understanding-bar__hint">正在理解你的问题</span>
      <span class="understanding-bar__dots"><i></i><i></i><i></i></span>
    </template>
    <template v-else>
      <span class="understanding-bar__text">{{ sentence }}</span>
      <span v-if="state === 'typing'" class="understanding-bar__dots"><i></i><i></i><i></i></span>
    </template>
  </div>
</template>

<script setup>
defineProps({
  // empty | typing | ready | ready_with_suggestion
  state: { type: String, default: 'empty' },
  sentence: { type: String, default: '' }
})
</script>

<style scoped lang="scss">
.understanding-bar {
  width: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 12px;
  font-size: 14px;
  box-sizing: border-box;

  &--empty {
    background: #f5f7fa;
    color: #909399;
  }

  &--typing {
    background: #eef1f5;
    color: #5b6b7a;
  }

  &--ready,
  &--ready_with_suggestion {
    background: #eef3f5;
    color: #5b7a8a;
  }

  &__placeholder,
  &__hint,
  &__text {
    line-height: 1.5;
  }

  // 三个点的轮询动画（打字指示器）
  &__dots {
    display: inline-flex;
    gap: 4px;
    margin-left: 6px;

    i {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: currentColor;
      animation: dot-bounce 1.2s infinite ease-in-out;

      &:nth-child(2) { animation-delay: 0.2s; }
      &:nth-child(3) { animation-delay: 0.4s; }
    }
  }
}

@keyframes dot-bounce {
  0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-3px); }
}
</style>
